import React from 'react';
import { NoResultsImage as NoResultsImageStyled } from './NoResultsImage.styles';

const NoResultsImage = () => (
  <NoResultsImageStyled
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="160px"
    height="130px"
    viewBox="0 0 160 130"
    version="1.1"
    preserveAspectRatio="none"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-108.000000, -287.000000)">
        <g transform="translate(20.000000, 279.000000)">
          <g transform="translate(88.000000, 0.000000)">
            <g transform="translate(1.136364, 8.000000)">
              <path
                d="M78.8636364,0 C118.628138,0 150.863636,32.235498 150.863636,72 C150.863636,82.7068161 148.526608,92.86779 144.334838,102.000635 L13.3924344,102.000635 C9.20066469,92.86779 6.86363636,82.7068161 6.86363636,72 C6.86363636,32.235498 39.0991344,0 78.8636364,0 Z"
                fill="#E1F0F6"
              />
              <line
                x1="8.18181818"
                y1="102.382979"
                x2="150"
                y2="102.382979"
                stroke="#45413C"
                strokeWidth="1.70212766"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="0"
                y1="102.382979"
                x2="4.54545455"
                y2="102.382979"
                stroke="#45413C"
                strokeWidth="1.70212766"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="152.636364"
                y1="102.382979"
                x2="157.181818"
                y2="102.382979"
                stroke="#45413C"
                strokeWidth="1.70212766"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g transform="translate(27.000000, 22.000000)">
              <g transform="translate(0.500000, 0.500000)">
                <path
                  d="M63.589,111.7735 C63.589,113.45175 53.614,114.81325 41.3045,114.81325 C28.995,114.81325 19.02,113.45 19.02,111.7735 C19.02,110.097 28.995,108.7355 41.3045,108.7355 C53.614,108.7355 63.589,110.09525 63.589,111.7735 Z"
                  fill="#45413C"
                  fillRule="nonzero"
                  opacity="0.15"
                />
                <g>
                  <g transform="translate(64.750000, 64.750000)">
                    <rect
                      stroke="#45413C"
                      strokeWidth="1.75"
                      fill="#B2B2B2"
                      fillRule="nonzero"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      transform="translate(9.217888, 9.195547) rotate(-45.000000) translate(-9.217888, -9.195547) "
                      x="3.31863771"
                      y="2.31542213"
                      width="11.7985"
                      height="13.76025"
                    />
                    <path
                      d="M37.71525,26.56775 C40.7862982,29.6383152 40.7866899,34.6170765 37.7161248,37.6881248 C34.6455598,40.7591732 29.6667984,40.759565 26.59575,37.689 L9.9165,21.008 C9.54760149,20.6396836 9.34030746,20.1397898 9.34030746,19.6185 C9.34030746,19.0972102 9.54760149,18.5973164 9.9165,18.229 L18.25,9.8885 C18.6186153,9.51949528 19.1187988,9.31215782 19.640375,9.31215782 C20.1619512,9.31215782 20.6621347,9.51949528 21.03075,9.8885 L37.71525,26.56775 Z"
                      fill="#C18353"
                      fillRule="nonzero"
                    />
                    <path
                      d="M14.085,14.05875 C14.4536153,13.6897453 14.9537988,13.4824078 15.475375,13.4824078 C15.9969512,13.4824078 16.4971347,13.6897453 16.86575,14.05875 L33.545,30.738 C35.8120746,33.0070177 36.4716057,36.4266032 35.211,39.376 C37.6192737,38.3547445 39.3632493,36.2042971 39.8651951,33.6370427 C40.3671409,31.0697883 39.5615339,28.4208502 37.71525,26.56775 L21.036,9.8885 C20.6673847,9.51949528 20.1672012,9.31215782 19.645625,9.31215782 C19.1240488,9.31215782 18.6238653,9.51949528 18.25525,9.8885 L14.09725,14.05"
                      fill="#E0A577"
                      fillRule="nonzero"
                    />
                    <path
                      d="M37.71525,26.56775 C40.7862982,29.6383152 40.7866899,34.6170765 37.7161248,37.6881248 C34.6455598,40.7591732 29.6667984,40.759565 26.59575,37.689 L9.9165,21.008 C9.54760149,20.6396836 9.34030746,20.1397898 9.34030746,19.6185 C9.34030746,19.0972102 9.54760149,18.5973164 9.9165,18.229 L18.25,9.8885 C18.6186153,9.51949528 19.1187988,9.31215782 19.640375,9.31215782 C20.1619512,9.31215782 20.6621347,9.51949528 21.03075,9.8885 L37.71525,26.56775 Z"
                      stroke="#45413C"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <g>
                    <circle
                      fill="#E5E5E5"
                      fillRule="nonzero"
                      cx="41.3045"
                      cy="41.28"
                      r="41.28075"
                    />
                    <circle
                      fill="#0DBEDC"
                      fillRule="nonzero"
                      transform="translate(41.303582, 41.280218) rotate(-76.718000) translate(-41.303582, -41.280218) "
                      cx="41.3035816"
                      cy="41.2802184"
                      r="32.4345"
                    />
                    <path
                      d="M41.3045,8.84547454 C28.1873551,8.84906235 16.3636687,16.7530389 11.3458238,28.8724751 C6.32797881,40.9919113 9.10393532,54.9406199 18.3795,64.2155 L64.24,18.34625 C58.1634158,12.2539049 49.9092329,8.83471069 41.3045,8.84547454 Z"
                      fill="#59DDEB"
                      fillRule="nonzero"
                    />
                    <circle
                      stroke="#45413C"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      transform="translate(41.303582, 41.280218) rotate(-76.718000) translate(-41.303582, -41.280218) "
                      cx="41.3035816"
                      cy="41.2802184"
                      r="32.4345"
                    />
                    <path
                      d="M82.39275,45.284 C80.4042121,24.0777302 62.6037996,7.86839556 41.3045,7.86839556 C20.0052004,7.86839556 2.20478791,24.0777302 0.21625,45.284 C0.0879166667,43.9656667 0.02375,42.631 0.02375,41.28 C0.02375,18.4812713 18.5057713,-0.00075 41.3045,-0.00075 C64.1032287,-0.00075 82.58525,18.4812713 82.58525,41.28 C82.58525,42.631 82.5205,43.975 82.39275,45.284 Z"
                      fill="#FFFFFF"
                      fillRule="nonzero"
                    />
                    <circle
                      stroke="#45413C"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      cx="41.3045"
                      cy="41.28"
                      r="41.28075"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </NoResultsImageStyled>
);

export default NoResultsImage;
